import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectExpandedModsDialog,
  selectIsEditExistingMod,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { FurnitureGrid } from './FurnitureGrid';
import { MiscFurnitureDesc } from './MiscFurnitureDesc';
import { UtilityGrid } from './UtilityGrid';
import { MiscUtilityDesc } from './MiscUtilityDesc';
import { furnitureModStyles } from './FurnitureMod.styles';
import { selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getFormattedFurniture, getFormattedUtility } from '../../ModificationsUtils';

export const FurnitureMod = () => {
  const { t } = useTranslation();

  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = furnitureModStyles({ isExpanded });
  const placementHeaderInfo = useSelector(selectPlacementHeaderData);
  const isModEdit = useSelector(selectIsEditMod);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedModsDetails?.furniture && (isModEdit || isEditExistingMod)) {
      dispatch(placementModsAction.setEditFurnitureRows(getFormattedFurniture(selectedModsDetails?.furniture)));
    }
    if (selectedModsDetails?.utilities && (isModEdit || isEditExistingMod)) {
      dispatch(placementModsAction.setEditUtilitiesRows(getFormattedUtility(selectedModsDetails?.utilities)));
    }
  }, [selectedModsDetails?.furniture, selectedModsDetails?.utilities, isModEdit]);
  return (
    <>
      <FurnitureGrid furnitureRequests={selectedModsDetails.furniture} isExpanded={isExpanded} />
      <Grid>
        <Grid item xs={12} className={classes.gridRow}>
          <Typography component="span" className={classes.billablelb}>{`${t(
            'placement.placementMods.billableToClient',
          )}`}</Typography>
          <Typography component="span" className={classes.billableValue}>
            {selectedModsDetails?.billable ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>
      <MiscFurnitureDesc isModEdit={isModEdit} />
      {placementHeaderInfo.facility.amnDivisionTypeId === 1 && (
        <>
          <UtilityGrid utilityRequests={selectedModsDetails.utilities} isExpanded={isExpanded} />
          <MiscUtilityDesc isModEdit={isModEdit} />
        </>
      )}
    </>
  );
};
